import {
    Component,
    ojs,
    app,
    payload,
    State,
    state,
    v,
} from "modular-openscriptjs";
import { dom, tool } from "../../fotastart";
import {
    either,
    lastOf,
    empty,
    each,
    cleanDispose,
    eParse,
    findByProperty,
    isMobile,
    consoleLogOnLocal,
} from "../../helpers";
import { api, STRINGS } from "../../declarations";
import OrderItem from "../Pages/OrderItem";
import DeliveryRequestView from "../Pages/DeliveryRequestView";
import Spinner, { SmallGlowSpinner } from "../Blocks/Spinner";
import OrderDetails, { AssignedDeliverer, OrderDeliveryAddress } from "../Pages/OrderDetails";
import { routes } from "../../backendRoutes";
import { $e } from "../../ojs.events";
import BsIcon from "../Blocks/BsIcon";

const h = app("h");
const broker = app("broker");
const ac = app("ac");
const dc = app("dc");

ojs(
    OrderItem,
    DeliveryRequestView,
    Spinner,
    OrderDetails,
    OrderDeliveryAddress,
    SmallGlowSpinner,
    BsIcon,
    AssignedDeliverer,
    
);

export default class ProcessOrderForm extends Component {
    holder = null;
    title = state("Order Information");
    activeNav = "details";

    render(order, ...args) {
        if (!order) return h.empty();

        return this.renderOrder(order, ...args);
    }

    renderOrder(orderState, ...args) {
        const order = orderState.value;

        const address = order?.delivery_address;
        const user = order?.user;
        const deliverer = order?.current_deliverer;
        const payments = order?.payments;
        const requests = order?.payment_requests;

        return h.div(
            {
                id: "carouselOrderDetails",
                class: "carousel slide carousel-fade",
                data_bs_touch: "false",
            },
            h.div(
                { class: "carousel-inner" },
                h.div(
                    { class: "carousel-item" },
                    h.OrderDetails(orderState, user),
                    either(this.activeNav == "details", { class: "active" }),
                ),
                h.div(
                    { class: "carousel-item" },
                    either(this.activeNav == "items", { class: "active" }),
                    either(
                        order?.type == "delivery_request",
                        () => h.DeliveryRequestView(order?.delivery_request, order?.status),
                        either(
                            order?.type == "errand",
                            () => {
                                const item = lastOf(order.items);
                                const errand = item.versioned_buyable;

                                return h.ErrandItem(errand, order);
                            },
                            () =>
                                this.renderOrderItems(order?.items, order?.status),
                        )
                    ),
                ),
                h.div(
                    { class: "carousel-item" },
                    either(this.activeNav == "locations", { class: "active" }),
                    h.OrderDeliveryAddress(address, order?.order_code, {
                        class: "p-3",
                    }),
                ),
                h.div(
                    { class: "carousel-item" },
                    either(this.activeNav == "customer", { class: "active" }),
                    h.CustomerDetails(user, order?.order_code),
                ),
                h.div(
                    { class: "carousel-item" },
                    either(this.activeNav == "payments", { class: "active" }),
                    either(
                        order?.surpluses && order?.surpluses.length > 0,
                        () =>
                            h.div(
                                { class: "d-flex flex-column gap-2 mb-3" },
                                h.h3(
                                    { class: "fs-sm fw-bold" },
                                    "Overpayments",
                                ),
                                h.OrderPaymentsSurpluses(order?.surpluses),
                            ),
                    ),

                    either(!empty(requests), () =>
                        h.div(
                            { class: "d-flex flex-column gap-2 mb-3" },
                            h.h3({ class: "fs-sm fw-bold" }, "Payment Top-ups"),
                            h.OrderPaymentRequests(requests),
                        ),
                    ),

                    h.div(
                        { class: "d-flex flex-column gap-2" },
                        h.h3({ class: "fs-sm fw-bold" }, "Payments Made"),
                        h.OrderPayments(payments),
                    ),
                ),

                h.div(
                    { class: "carousel-item" },
                    either(this.activeNav == "deliverer", { class: "active" }),
                    h.AssignedDeliverer(deliverer, order),
                ),

                h.div(
                    { class: "carousel-item" },
                    either(this.activeNav == "pay", { class: "active" }),
                    h.ErrandPaymentForm(order),
                ),
            ),
            ...args,
        );
    }

    renderOrderItems(items, status, ...args) {
        return h.div(
            { class: "d-flex flex-column gap-3" },
            each(items, (item) => {
                return h.OrderItem(item, status);
            }),
            ...args,
        );
    }

    $$order = {
        needs: {
            processForm: (ed, event) => {
                this.showForm(ed, event);
            },

            to: {
                close: {
                    processForm: (ed, event) => this.closeForm(),
                },
            },
        },

        statusChanged: (ed, event) => this.closeForm(),
        
        is: {
            transferred: () => this.closeForm(),
        }
    };

    async showForm(ed, event) {
        if (this.holder) {
            cleanDispose(this.holder);
        }

        let data = eParse(ed);
        const orderId = data.message.get("orderId", 0);

        const order = ac.orders.value[orderId];

        ac.activeOrder.value = order;
        this.activeNav = "details";

        setTimeout(async () => {
            let res = await api.get(`${routes.orders}/${orderId}`);

            if (!res) {
                return;
            }

            let order = res.data.order;
            ac.activeOrder.value = order;
        }, 100);

        if (isMobile()) {
            this.holder = tool.offcanvas(
                [
                    v(
                        ac.activeOrder,
                        (order) => {
                            if (empty(order.value)) {
                                return h.Spinner();
                            }

                            return this.renderOrder(order);
                        },
                        {
                            $class: "offcanvas-body",
                            class: "d-block",
                        },
                    ),

                    h.div(
                        {
                            class: "offcanvas-footer border-top admin-order-view",
                        },

                        h.nav(
                            { class: "offcanvas-nav" },

                            h.ul(
                                { class: "d-flex flex-items-equal nav" },
                                h.li(
                                    { class: "nav-item" },

                                    h.a(
                                        {
                                            class: "nav-link d-flex flex-column gap-2 align-items-center py-3 active",
                                            href: "#",
                                            data_bs_target:
                                                "#carouselOrderDetails",
                                            data_bs_slide_to: "0",
                                            aria_label: "Order details",
                                            pof_link: true,
                                            onclick: this.method("selectTab", [
                                                "${this}",
                                                "Order Information",
                                                "details",
                                            ]),
                                        },

                                        h.span(
                                            { class: "icon" },
                                            h.i({
                                                class: "bi bi-info-circle fs-3 text-black",
                                            }),
                                        ),

                                        h.span(
                                            { style: "font-size: xx-small;" },
                                            "Details",
                                        ),
                                    ),
                                ),

                                h.li(
                                    { class: "nav-item" },

                                    h.a(
                                        {
                                            class: "nav-link d-flex flex-column gap-2 align-items-center py-3",
                                            href: "#",
                                            data_bs_target:
                                                "#carouselOrderDetails",
                                            data_bs_slide_to: "1",
                                            aria_label: "Ordered items",
                                            pof_link: true,
                                            onclick: this.method("selectTab", [
                                                "${this}",
                                                order?.delivery_request_id
                                                    ? "Delivery Details"
                                                    : (order?.type == "errand"
                                                        ? "Steps to Complete"
                                                        : "Order Items"),
                                                "items",
                                            ]),
                                        },

                                        h.i({
                                            class: "bi bi-tags fs-3 text-black",
                                        }),

                                        h.span(
                                            { style: "font-size: xx-small;" },
                                            either(
                                                order?.type == "delivery_request",
                                                "Delivery",
                                                either(
                                                    order?.type == "errand",
                                                    "Work",
                                                    "Items",
                                                )
                                            ),
                                        ),
                                    ),
                                ),

                                h.li(
                                    { class: "nav-item" },

                                    either(order?.type == "errand" || order?.type == "delivery_request", {
                                        class: "d-none",
                                    }),

                                    h.a(
                                        {
                                            class: "nav-link d-flex flex-column gap-2 align-items-center py-3",
                                            href: "#",
                                            data_bs_target:
                                                "#carouselOrderDetails",
                                            data_bs_slide_to: "2",
                                            aria_label: "Delivery address",
                                            pof_link: true,
                                            onclick: this.method("selectTab", [
                                                "${this}",
                                                "Delivery Address",
                                                "locations",
                                            ]),
                                        },

                                        h.i({
                                            class: "bi bi-geo-alt fs-3 text-black",
                                        }),

                                        h.span(
                                            { style: "font-size: xx-small;" },
                                            "Address",
                                        ),
                                    ),
                                ),
                            ),
                        ),
                    ),
                ],
                h.div(
                    {
                        class: "offcanvas-header border-bottom justify-content-between",
                        style: "--bs-offcanvas-padding-y: 1rem",
                    },

                    h.div(
                        { class: "d-flex align-items-center gap-4" },

                        h.button(
                            {
                                type: "button",
                                class: "btn btn-cta",
                                data_bs_dismiss: "offcanvas",
                                aria_label: "Close",
                                style: "margin-left: -8px;",
                            },

                            h.i({ class: "bi bi-arrow-left fs-3" }),
                        ),
                        v(this.title, (state) => {
                            return h.h5(
                                {
                                    class: "offcanvas-title fw-400 text-black",
                                    id: "offcanvasOrderDetailsLabel",
                                },

                                state.value,
                            );
                        }),
                    ),

                    v(dc.selectedItems, (selectedItems) => {
                        if (Object.keys(selectedItems.value).length < 1)
                            return null;

                        return h.div(
                            {
                                class: "border border-3 p-2 positive-relative rounded-3",
                                listeners: {
                                    click: () => {
                                        broker.send($e.purchase.needs.creation);
                                    },
                                },
                            },

                            h.span({ class: "fs-sm" }, "Make Purchases"),

                            h.span(
                                {
                                    class: "bg-danger circle fs-xsm position-absolute text-white",
                                    style: "--size: 20px; top: 9px;",
                                },
                                Object.keys(selectedItems.value).length,
                            ),
                        );
                    }),
                    h.div(
                        h.button(
                            {
                                type: "button",
                                class: "btn btn-cta",
                                data_bs_target: "#carouselOrderDetails",
                                data_bs_slide_to: "5",
                                aria_label: "Assigned deliverer",
                                style: "margin-right: -5px",
                                pof_link: true,
                                onclick: this.method("selectTab", [
                                    "${this}",
                                    "Assigned Deliverer",
                                    "deliverer",
                                ]),
                            },

                            h.i({
                                class: "bi bi-bicycle fs-3",
                            }),
                        ),
                    ),
                ),
            );
        } else {
            this.holder = tool.plainModal(
                h.div(
                    { class: "modal-content border-0 rounded-5 p-4" },
                    h.div(
                        {
                            class: "modal-header border-bottom justify-content-between",
                            style: "--bs-offcanvas-padding-y: 1rem",
                        },

                        h.div(
                            { class: "d-flex align-items-center gap-4" },

                            h.button(
                                {
                                    type: "button",
                                    class: "btn btn-cta",
                                    data_bs_dismiss: "modal",
                                    aria_label: "Close",
                                    style: "margin-left: -8px;",
                                },

                                h.i({ class: "bi bi-arrow-left fs-3" }),
                            ),
                            v(this.title, (state) => {
                                return h.h5(
                                    {
                                        class: "offcanvas-title fw-400 text-black",
                                        id: "offcanvasOrderDetailsLabel",
                                    },

                                    state.value,
                                );
                            }),
                        ),

                        h.div(
                            h.button(
                                {
                                    type: "button",
                                    class: "btn btn-cta",
                                    data_bs_target: "#carouselOrderDetails",
                                    data_bs_slide_to: "5",
                                    aria_label: "Assigned deliverer",
                                    style: "margin-right: -5px",
                                    pof_link: true,
                                    onclick: this.method("selectTab", [
                                        "${this}",
                                        "Assigned Deliverer",
                                        "deliverer",
                                    ]),
                                },

                                h.i({
                                    class: "bi bi-bicycle fs-3",
                                }),
                            ),
                        ),
                    ),
                    this.renderOrder(ac.activeOrder),
                    h.div(
                        {
                            class: "modal-footer border-top admin-order-view",
                        },

                        h.nav(
                            { class: "offcanvas-nav" },

                            h.ul(
                                { class: "d-flex flex-items-equal nav" },
                                h.li(
                                    { class: "nav-item" },

                                    h.a(
                                        {
                                            class: "nav-link d-flex flex-column gap-2 align-items-center py-3 active",
                                            href: "#",
                                            data_bs_target:
                                                "#carouselOrderDetails",
                                            data_bs_slide_to: "0",
                                            aria_label: "Order details",
                                            pof_link: true,
                                            onclick: this.method("selectTab", [
                                                "${this}",
                                                "Order Information",
                                                "details",
                                            ]),
                                        },

                                        h.i({
                                            class: "bi bi-info-circle fs-3 text-black",
                                        }),
                                        h.span(
                                            {
                                                style: "font-size: xx-small;",
                                            },
                                            "Details",
                                        ),
                                    ),
                                ),

                                h.li(
                                    { class: "nav-item" },

                                    h.a(
                                        {
                                            class: "nav-link d-flex flex-column gap-2 align-items-center py-3",
                                            href: "#",
                                            data_bs_target:
                                                "#carouselOrderDetails",
                                            data_bs_slide_to: "1",
                                            aria_label: "Ordered items",
                                            pof_link: true,
                                            onclick: this.method("selectTab", [
                                                "${this}",
                                                order?.delivery_request_id
                                                    ? "Delivery Details"
                                                    : (order?.type == "errand"
                                                        ? "Steps To Complete"
                                                        : "Order Items"),
                                                "items",
                                            ]),
                                        },

                                        h.i({
                                            class: "bi bi-tags fs-3 text-black",
                                        }),

                                        h.span(
                                            {
                                                style: "font-size: xx-small;",
                                            },
                                            either(
                                                order?.type == "delivery_request",
                                                "Delivery",
                                                either(
                                                    order?.type == "errand",
                                                    "Work",
                                                    "Items",
                                                )
                                            ),
                                        ),
                                    ),
                                ),

                                h.li(
                                    { class: "nav-item" },

                                    either(order?.type == "errand" || order?.type == "delivery_request", {
                                        class: "d-none",
                                    }),

                                    h.a(
                                        {
                                            class: "nav-link d-flex flex-column gap-2 align-items-center py-3",
                                            href: "#",
                                            data_bs_target:
                                                "#carouselOrderDetails",
                                            data_bs_slide_to: "2",
                                            aria_label: "Delivery address",
                                            pof_link: true,
                                            onclick: this.method("selectTab", [
                                                "${this}",
                                                "Delivery Address",
                                                "locations",
                                            ]),
                                        },

                                        h.i({
                                            class: "bi bi-geo-alt fs-3 text-black",
                                        }),

                                        h.span(
                                            {
                                                style: "font-size: xx-small;",
                                            },
                                            "Address",
                                        ),
                                    ),
                                ),
                            ),
                        ),
                    ),
                ),
                {},
            );
        }

        this.holder.show();
    }

    closeForm() {
        this.holder.hide();
    }

    selectTab(linkElem, title, name) {
        let currentLink = dom.get("[pof-link='true'].active");

        if (currentLink) {
            currentLink.classList.remove("active");
        }

        linkElem.classList.add("active");

        this.title.value = title;
        this.activeNav = name;
    }

    viewPurchase(itemId) {
        broker.send($e.purchase.needs.display, payload({ itemId }));
    }

    $$purchase = {
        is: {
            confirming: (ed, event) => {
                let data = eParse(ed);

                if (data.meta.type == "errand") return;

                let items = data.message.get("itemsPurchased", {});

                for (const id in items) {
                    let btn = dom.id(`order-item-${id}-purchase-btn`);

                    if (btn) {
                        h.button(
                            {
                                class: "btn btn-outline-secondary rounded-pill shadow-sm w-100 py-2 fw-bold d-flex align-items-center justify-content-center gap-2",
                                disabled: true,
                                replaceParent: true,
                                parent: btn,
                            },
                            h.span("Purchasing"),
                            h.SmallGlowSpinner(),
                        );
                    }
                }
            },
        },

        failed_completed: (ed, event) => {
            let data = eParse(ed);
            if (data.meta.type == "errand") return;
            let items = data.message.get("itemsPurchased", {});

            for (const id in items) {
                let item = items[id];

                if (event == $e.purchase.completed) {
                    let holder = dom.id(
                        `order-item-${item.id}-purchase-btn-holder`,
                    );
                    if (holder) {
                        h.div(
                            {
                                class: "d-flex align-items-center justify-content-center gap-2 text-success fw-bold py-2 w-100",
                                style: "cursor: pointer;",
                                onclick: this.method("viewPurchase", item.id),
                                id: `order-item-${item.id}-purchases`,
                                replaceParent: true,
                                parent: holder,
                            },
                            h.i({
                                class: "bi bi-check-circle-fill text-success fs-5",
                            }),
                            h.span("View Purchases"),
                        );
                    }
                }
            }
        },
    };
}
